import React from 'react';
import { Analytics } from '@vercel/analytics/react';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Books from './components/Books';
import ComingSoon from './components/ComingSoon';
import Testimonials from './components/Testimonials';
import Instagram from './components/Instagram';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="app-shell">
      <Header />
      <main>
        <Hero />
        <About />
        <Books />
        <ComingSoon />
        <Testimonials />
        <Instagram />
        <Contact />
      </main>
      <Footer />
      <Analytics />
    </div>
  );
}

export default App;